const localDateKey = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const eventDateKey = (value) => {
  if (!value) return null;
  const calendarDate = String(value).match(/^(\d{4}-\d{2}-\d{2})/);
  if (calendarDate) return calendarDate[1];
  return localDateKey(new Date(value));
};

export const isWithinEventPeriod = (event, now = new Date()) => {
  const start = eventDateKey(event?.start_date);
  if (!start) return false;

  const end = eventDateKey(event?.end_date) || start;
  const today = localDateKey(now);
  if (!today || end < start) return false;

  return today >= start && today <= end;
};
